/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Form base
 */
import React, { Component } from 'react';
import { FlatButton, Dialog } from 'material-ui';
import { FormBuilder } from '../components/data-containers';
import { getConfig as initDespacho } from './despacho';
import { getConfig as initAduana } from './aduana';
import { getConfig as initUser } from './user';
import { getConfig as initCliente } from './cliente';
import { getConfig as initConcepto } from './concepto';
import { getConfig as initStatus } from './status';
import { getConfig as initProveedor } from './proveedor';
import { getConfig as initTabulador } from './tabulador';

const forms = {
    despacho: (actions, params, formState) => initDespacho(actions, params, formState),
    aduana: (actions) => initAduana(actions),
    user: (actions) => initUser(actions),
    cliente: (actions, params) => initCliente(actions, params),
    concepto: (actions) => initConcepto(actions),
    status: (actions) => initStatus(actions),
    proveedor: (actions) => initProveedor(actions),
    tabulador: (actions) => initTabulador(actions)
};

const createActions = (onCancel, onSave, { isValid, form }) => {
    return [
        <FlatButton
            label="Cancelar"
            primary
            onTouchTap={onCancel}
        />,
        <FlatButton
            label="Guardar"
            primary
            keyboardFocused
            disabled={!isValid}
            onTouchTap={() => isValid && onSave(form)}
        />
    ];
};

class Form extends Component {
    constructor() {
        super();
        this.state = { isValid: false, form: {} };
    }

    render() {
        const { onModalClosed, onSave, open, type, title, actions, params } = this.props;
        const config = forms[type](actions, params, this.state.form);
        const dialogActions = createActions(onModalClosed, onSave, this.state);
        return (
            <Dialog
                title={<div>{title} <h5>Campos obligatorios (*)</h5></div>}
                className="modalstyle"
                actions={dialogActions}
                modal
                open={open}
                onRequestClose={onModalClosed}
                autoScrollBodyContent
            >
                <FormBuilder
                    config={config}
                    onFormChange={(isValid, form) => {
                        this.setState({ isValid, form });
                    }}
                />
            </Dialog>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./forms/index.js